import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Button } from '@frekuent/orbit/components';

const NotFoundPage: React.FC = () => {
	const navigate = useNavigate();
	const { t } = useTranslation('common');

	return (
		<div className='min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8'>
			<div className='max-w-md w-full text-center'>
				<h1 className='text-9xl font-bold text-gray-900'>404</h1>
				<p className='mt-2 text-3xl font-bold text-gray-900'>{t('notFound.title')}</p>
				<p className='mt-2 text-lg text-gray-600'>{t('notFound.description')}</p>
				<Button
					variant='highlighted'
					className='mt-6 mx-auto'
					onClick={() => navigate('/')}
				>
					{t('notFound.backButton')}
				</Button>
			</div>
		</div>
	);
};

export default NotFoundPage;
